import { render, staticRenderFns } from "./rtuList3_forV3LunGuan.vue?vue&type=template&id=510d07b2&scoped=true"
import script from "./rtuList3_forV3LunGuan.vue?vue&type=script&lang=js"
export * from "./rtuList3_forV3LunGuan.vue?vue&type=script&lang=js"
import style0 from "./rtuList3_forV3LunGuan.vue?vue&type=style&index=0&id=510d07b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510d07b2",
  null
  
)

export default component.exports